"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = void 0;
const gl_matrix_1 = require("gl-matrix");
/**
 * Circle Shape
 */
class Circle {
    /**
     * Private constructor, use static creation methods instead.
     *
     * @param center Center of the circle
     * @param radius Radius of the circle
     */
    constructor(center, radius) {
        this.center = center;
        this.radius = radius;
    }
    /**
     * Creates a Circle instance described by the circle JSON.
     *
     * @param circleJson The circle JSON
     */
    static fromJson(circleJson) {
        return new Circle(gl_matrix_1.vec2.fromValues(circleJson.Center[0], circleJson.Center[1]), circleJson.Radius);
    }
    /**
     * Creates an JSON object out of the circle instance.
     */
    toJson() {
        return {
            Center: [this.center[0], this.center[1]],
            Radius: this.radius,
        };
    }
    /**
     * Test if the point is inside the circle or on the circle contour.
     *
     * @param point A 2D point
     */
    isPointInShape(point) {
        return gl_matrix_1.vec2.squaredDistance(this.center, point) <= this.radius * this.radius;
    }
    /**
     * Transform the circle by the given matrix.
     *
     * @param transform The transformation matrix.
     */
    transform(transform) {
        const transformedCenter = gl_matrix_1.vec2.create();
        gl_matrix_1.vec2.transformMat2d(transformedCenter, this.center, transform);
        const scaleX = transform[0];
        const transformedRadius = this.radius * scaleX;
        return new Circle(transformedCenter, transformedRadius);
    }
}
exports.Circle = Circle;
//# sourceMappingURL=Circle.js.map